import React, {useCallback, useEffect, useState} from 'react';
import Scrollbars from "react-custom-scrollbars-2";
import useWindowDimensions from "../Wedgits/useWindowDimensions";
import "../Css/Aboutus.scss";
import leaf from "../Backgrounds/topContainer.svg";
import ImageRight from "../Backgrounds/ImageRight.png";
import ImageLeft from "../Backgrounds/ImageLeft.png";
import axios from "axios";
import toast from "react-hot-toast";
import {Link} from "react-router-dom";

function AboutUs(props) {

    const {height, width} = useWindowDimensions();

    const [isLoading, setIsloading] = useState(false);
    const [error, setError] = useState(null);
    const [branchData, setBranchData] = useState("");
    let newTime = new Date().getTime();

    const fetchBranches = useCallback(async () => {
        setIsloading(true);
        setError(null);

        try {
            const Response = await axios.get(`/v1/branches`, {
                headers: {
                    Authorization: localStorage.getItem("token"),
                    "branch-code": axios.defaults.url,
                },
            });
            if (Response.status == 200) {
                setBranchData(Response.data.data.d[0]);
                props.onSetIsFetchOver(true);
            }
        } catch (error) {
            toast.error(error.response.data.errors[0].msg);
            if ((error?.response?.status ?? 0) === 401) {
                localStorage.removeItem("token");
                // //console.log(error);
                setTimeout(() => {
                    window.location = "/";
                }, 2000);
            }
        }

        setIsloading(false);
    }, []);

    const getStatistics = useCallback(async () => {
        setIsloading(true);
        setError(null);
        let date = new Date();
        try {
            const Response = await axios.patch(
                `/v1/branches/statistics/menu_clicks`,
                {},
                {
                    headers: {
                        Authorization: localStorage.getItem("token"),
                        "branch-code": axios.defaults.url,
                    },
                }
            );
            if (Response.status == 200) {
                localStorage.setItem("statistics", date.getTime());
            }
        } catch (error) {
            toast.error(error.response.data.errors[0].msg);
            if ((error?.response?.status ?? 0) === 401) {
                localStorage.removeItem("token");
                // //console.log(error);
                setTimeout(() => {
                    window.location = "/";
                }, 2000);
            }
        }

        setIsloading(false);
    }, []);

    useEffect(() => {
        fetchBranches();
        if (!localStorage.getItem("statistics")) {
            getStatistics();
        } else {
            if ((parseInt(newTime) - parseInt(localStorage.getItem("statistics"))) > 600000) {
                getStatistics();
            }
        }
    }, []);

    return (
        <div className="aboutUsContainer">
            <div className="blankSpace"></div>

            <Scrollbars
                autoHide
                autoHideTimeout={1000}
                style={{minHeight: height, height: "auto"}}
            >
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>

                {/*<div className="TitleContent">*/}
                {/*    <div className="leafLeft">*/}
                {/*        <img src={leaf} alt="leafDesign"/>*/}
                {/*    </div>*/}
                {/*    <h4>درباره ما </h4>*/}
                {/*    <div className="leafRight">*/}
                {/*        <img src={leaf} alt="leafDesign"/>*/}
                {/*    </div>*/}
                {/*</div>*/}

                <div className="row">
                    <div className="TextContent">
                        <h1>
                            فردیس،
                        </h1>
                        <h3>
                            خاطره‌ای با قدمت سی ساله
                        </h3>
                        <p>
                            به رستوران سنتی فردیس در قلب طبیعت زیبای طرقبه خوش آمدید
                            رستوران زیبای فردیس نگاهی متفاوت به غذای ایرانی در محیطی دل‌نشین و آرامش‌بخش است .
                            <br/>
                            فضای باز فردیس تجربه ی بی نظیر همراهی طعم عالی غذاست با صدای آرامبخش طبیعت
                            و فضای سرپوشیده فردیس میزبان میهمانان عزیز در هر فصل سال است.
                            <br/>
                            {width > 700 &&
                                "                            ما در فردیس مفتخر به ارائه انواع غذاهای اصیل ایرانی با بهترین مواد اولیه هستیم."
                            }
                            <br/>
                            {width > 700 &&
                                " برگزاری جشن ها و مناسبتها با تشریفات خاص تخصص ماست تا شما مهمان مراسم خود باشید."
                            }
                            <br/>
                            {width > 700 &&
                                "در انتظار حضور شما در تمام روزهای هفته هستیم ."
                            }
                        </p>
                    </div>
                    <div className="imgContainer">
                        <div className="leftImages">
                            <img src="./photo_2024-07-17_11-02-33 copy.webp" alt="صاویر مجموعه فردیس"/>
                        </div>
                        <div className="rightImages">
                            <img src="./photo_2024-07-17_11-02-38 copy.webp" alt="صاویر مجموعه فردیس"/>
                            <img src="./photo_2024-07-17_11-39-21 copy.webp" alt="صاویر مجموعه فردیس"/>
                        </div>
                    </div>
                </div>

                {width < 700 &&
                    <div className="row">
                        <div className="TextContent">
                            <p>
                                ما در فردیس مفتخر به ارائه انواع غذاهای اصیل ایرانی با بهترین مواد اولیه هستیم.
                                برگزاری جشن ها و مناسبتها با تشریفات خاص تخصص ماست تا شما مهمان مراسم خود باشید.
                                در انتظار حضور شما در تمام روزهای هفته هستیم .
                            </p>
                        </div>
                        <div className="imgContainer">
                            <div className="centerImages">
                                <img src="./photo_2024-07-17_11-02-38 copy.webp" alt="صاویر مجموعه فردیس"/>
                            </div>
                        </div>
                    </div>
                }

                <div className="TitleContent">
                    <div className="leafLeft">
                        <img src={leaf} alt="leafDesign"/>
                    </div>
                    <h4>منو فردیس</h4>
                    <div className="leafRight">
                        <img src={leaf} alt="leafDesign"/>
                    </div>
                </div>

                <div className="menuContainer">
                    <div className="leftImgContainer">
                        <img src={ImageLeft} alt="منو فردیس"/>
                        <h4>غذای خوب در محیطی دنج و آرام</h4>
                        <p>
                            رستوران فردیس با افتخار تلاش می‌کند تا با مجموعه‌ای از غذاهای ایرانی ناب و اصیل، تهیه‌شده از
                            بهترین مواد اولیه و هنر دست سرآشپزان ماهر پذیرای مهمانان خود باشد.
                            منوی غذایی فردیس مجموعه ای متنوع از بی‌نظیرهاست .
                        </p>

                        <Link to={"/menu"}>
                            <button>
                                مشاهده منو
                            </button>
                        </Link>
                    </div>

                    <div className="rightImgContainer">
                        <img src={ImageRight} alt="منو فردیس"/>
                    </div>
                </div>

                <div className="TitleContent">
                    <div className="leafLeft">
                        <img src={leaf} alt="leafDesign"/>
                    </div>
                    <h4>افتخارات فردیس </h4>
                    <div className="leafRight">
                        <img src={leaf} alt="leafDesign"/>
                    </div>
                </div>

                <div className="Achievements">
                    <p>
                        رستوران فردیس از سال ۱۳۸۰ تا به امروز همواره در حال ارتقاء و پیشرفت بوده که حاصل پیمودن این مسیر
                        موفق، دریافت گواهینامه ها و تقدیرنامه هایی است که نتیجه اعتماد مشتریان گرامیست. فردیس همیشه
                        قدردان وفاداری شماست.
                    </p>
                    <div className="AchievementsImg">
                        <img src="./certificate1.png" alt="گواهینامه های فردیس"/>
                        <img src="./certificate2.png" alt="گواهینامه های فردیس"/>
                        <img src="./certificate3.png" alt="گواهینامه های فردیس"/>
                        <img src="./certificate4.png" alt="گواهینامه های فردیس"/>
                        <img src="./certificate5.png" alt="گواهینامه های فردیس"/>
                        <img src="./certificate6.png" alt="گواهینامه های فردیس"/>
                    </div>
                </div>

                <br/>
                <br/>

                <div className="row socialmediaLinks">
                    <a href={branchData?.links?.google_map} target="_blank">
                        <svg xmlns="http://www.w3.org/2000/svg" width="44" height="57" viewBox="0 0 44 57" fill="none">
                            <path
                                d="M22 54.8386C21.4171 54.2225 20.6214 53.3663 19.6802 52.3147C17.6384 50.0333 14.9191 46.8405 12.2034 43.1905C9.48421 39.5358 6.79059 35.452 4.78233 31.387C2.76277 27.2991 1.5 23.3561 1.5 19.95C1.5 9.89786 10.5399 1.5 22 1.5C33.4601 1.5 42.5 9.89786 42.5 19.95C42.5 23.3561 41.2372 27.2991 39.2177 31.387C37.2094 35.452 34.5158 39.5358 31.7966 43.1905C29.0809 46.8405 26.3616 50.0333 24.3198 52.3147C23.3786 53.3663 22.5829 54.2225 22 54.8386ZM12.6429 19.95C12.6429 24.8461 16.9759 28.575 22 28.575C27.0241 28.575 31.3571 24.8461 31.3571 19.95C31.3571 15.0539 27.0241 11.325 22 11.325C16.9759 11.325 12.6429 15.0539 12.6429 19.95Z"
                                stroke="white" stroke-width="3"/>
                        </svg>
                    </a>
                    <a href={`tel:${branchData?.phone}`} target="_blank">
                        <svg xmlns="http://www.w3.org/2000/svg" width="59" height="58" viewBox="0 0 59 58" fill="none">
                            <path
                                d="M36.7749 6.58795C40.3479 7.54688 43.6059 9.42873 46.2218 12.0447C48.8377 14.6606 50.7196 17.9185 51.6785 21.4916"
                                stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                            <path
                                d="M31.8071 11.5558C35.3845 12.5059 38.6472 14.3848 41.2645 17.0021C43.8818 19.6194 45.7607 22.8821 46.7107 26.4595"
                                stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                            <path
                                d="M17.6206 29.1315C20.07 34.1897 24.1601 38.2693 29.2245 40.7056C29.598 40.8825 30.0112 40.9591 30.4234 40.9278C30.8355 40.8965 31.2324 40.7584 31.575 40.5271L39.0134 35.5583C39.342 35.3354 39.7218 35.1994 40.1172 35.163C40.5126 35.1265 40.9108 35.1909 41.2746 35.35L55.1993 41.3305C55.6752 41.5285 56.0728 41.8776 56.3308 42.3238C56.5889 42.77 56.6931 43.2887 56.6274 43.8C56.1861 47.2447 54.5047 50.4105 51.898 52.7051C49.2912 54.9998 45.9376 56.2659 42.4648 56.2667C31.7328 56.2667 21.4405 52.0035 13.8519 44.4149C6.26324 36.8262 2 26.5339 2 15.8019C2.00078 12.3291 3.26695 8.97554 5.56157 6.36876C7.85619 3.76198 11.022 2.08062 14.4667 1.63928C14.978 1.5736 15.4967 1.67782 15.9429 1.93588C16.3892 2.19394 16.7382 2.59154 16.9363 3.06744L22.9167 17.0218C23.0722 17.3799 23.1373 17.7707 23.1062 18.1599C23.075 18.549 22.9487 18.9246 22.7382 19.2534L17.7694 26.8107C17.5481 27.1526 17.4183 27.5454 17.3923 27.9517C17.3662 28.358 17.4448 28.7643 17.6206 29.1315Z"
                                stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </a>
                    <a href={branchData?.links?.instagram} target="_blank">
                        <svg xmlns="http://www.w3.org/2000/svg" width="58" height="58" viewBox="0 0 58 58" fill="none">
                            <g clip-path="url(#clip0_353_214)">
                                <path
                                    d="M29 43.2563C21.0676 43.2563 14.6218 36.8105 14.6218 28.8782C14.6218 20.9458 21.0676 14.5 29 14.5C36.9323 14.5 43.3781 21.0798 43.3781 28.8782C43.3781 36.6765 36.9323 43.2563 29 43.2563ZM29 17.6681C22.8222 17.6681 17.7899 22.7004 17.7899 28.8782C17.7899 35.0559 22.8222 40.0882 29 40.0882C35.1777 40.0882 40.2101 35.0559 40.2101 28.8782C40.2101 22.7004 35.1777 17.6681 29 17.6681Z"
                                    fill="white"/>
                                <path
                                    d="M45.206 15.2311C46.4846 15.2311 47.5211 14.1946 47.5211 12.916C47.5211 11.6373 46.4846 10.6008 45.206 10.6008C43.9274 10.6008 42.8909 11.6373 42.8909 12.916C42.8909 14.1946 43.9274 15.2311 45.206 15.2311Z"
                                    fill="white"/>
                                <path
                                    d="M16.5714 58C11.8315 58 7.7374 56.4769 4.73992 53.5891C1.63277 50.5916 0 46.3878 0 41.4286V16.4496C0 6.45798 6.45798 0 16.4496 0H41.5504C46.4366 0 50.555 1.59622 53.4672 4.61807C56.4403 7.59118 58 11.6731 58 16.4496V41.5504C58 46.5097 56.4038 50.6769 53.3819 53.5891C50.3845 56.4769 46.2416 58 41.4286 58H16.5714ZM16.5714 3.16807C12.5504 3.16807 9.08992 4.42311 6.81134 6.6895C4.42311 9.07773 3.16807 12.4529 3.16807 16.4496V41.4286C3.16807 45.5592 4.39874 48.8857 6.81134 51.3105C9.2605 53.6256 12.6235 54.8319 16.5714 54.8319H41.4286C45.3765 54.8319 48.7395 53.6256 51.1643 51.3349C53.7231 48.9101 55.0756 45.5349 55.0756 41.5504V16.4496C55.0756 12.721 53.784 9.30924 51.4567 6.83571C49.0441 4.42311 45.6689 3.16807 41.6723 3.16807H16.5714Z"
                                    fill="white"/>
                            </g>
                            <defs>
                                <clipPath id="clip0_353_214">
                                    <rect width="58" height="58" fill="white"/>
                                </clipPath>
                            </defs>
                        </svg>
                    </a>
                </div>

                {/*<div className="TitleContent">*/}
                {/*    <div className="leafLeft">*/}
                {/*        <img src={leaf} alt="leafDesign"/>*/}
                {/*    </div>*/}
                {/*    <h4>افتخار میزبانی </h4>*/}
                {/*    <div className="leafRight">*/}
                {/*        <img src={leaf} alt="leafDesign"/>*/}
                {/*    </div>*/}
                {/*</div>*/}

                {/*<div className="HostAchievement">*/}
                {/*    <div className="circleImage">*/}
                {/*        <img src="./4dfdaabfe35c41207ee1661968fa7600.jpeg" alt="گواهینامه های فردیس"/>*/}
                {/*    </div>*/}
                {/*    <p>بسیار ممنون از خدمات بسیار عالی که ارايه دادید</p>*/}
                {/*</div>*/}

                <div className="blankSpace"></div>
            </Scrollbars>
        </div>
    );
}

export default AboutUs;
